import { Product, Offer } from './types';

export const mapDataToProps = (
  item: Product | Offer,
  type?: 'product' | 'offer'
) => {
  switch (type) {
    case 'product': {
      const product = item as Product;
      return {
        type: 'product',
        id: product.id,
        brand: product.brand,
        imageSrc: product.media?.first,
        name: product.name,
        link: product.pathName,
        properties: product.properties?.nodes,
        price: product.priceSummary?.regular,
        priceInclShipping: product.priceSummary?.includeShipping,
        rank: product.popularity?.inCategory,
        rating: product.userReviewSummary?.rating,
        reviewsCount: product.userReviewSummary?.count,
        category: product.category,
      };
    }
    case 'offer': {
      const offer = item as Offer;
      return {
        type: 'offer',
        imageSrc: offer.media?.first,
        link: offer.externalUri,
        name: offer.name,
        price: offer.offerPrice,
        store: offer.store,
      };
    }
    default:
      return {};
  }
};
